<template>
  <div id="app">
    <page-header></page-header>
    <router-view></router-view>
    <div class="copy-right">
      Copyright &copy; 2019 透透医美 备案号：蜀ICP备18010216号-1 <br />
      联系地址：中国(四川)自由贸易试验区成都高新区天府软件园B区
    </div>
  </div>
</template>

<script>
import pageHeader from '@/components/pageHeader'

export default {
  name:'app',
  data() {
    return {
    }
  },
  methods: {
  },
  components:{
    pageHeader
  }
}

</script>

<style scoped>
body, html {
  height: 100%;
}
#app{
  font-size: 16px;
  color:#333;
  position: relative;
  height: 100%;
}
.case-wrapper {
  padding-top: 78px;
}
@media (max-width: 710px) {
    .copy-right {
      display: none;
    }
    .case-wrapper {
        padding-top: 68px;
    }
}
.copy-right {
  width: 100vw;
  text-align: center;
  height: 92px;
  color: #666666;
  background: #D8D8D8;
  font-size: 12px;
  display: table-cell;
  vertical-align: middle;
}
</style>
